<script setup lang="ts">
import Button from '@ui/components/forms/button.vue';
import { useLogin } from '@app/components/login/useLogin';

const { sso, onSSO } = useLogin();
</script>
<template>
    <Button
        v-for="action in sso"
        :key="action.name"
        v-tooltip="action.tooltip"
        :name="action.name"
        :icon="action.icon"
        @click="onSSO(action)"
    >
        <span class="mr-5">
            {{ action.title }}
        </span>
    </Button>
</template>
